module.exports = __webpack_public_path__ + "static/media/corego-success-story-banner.e82d39f4.webp";